import React, {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {UserContext} from 'components/user/UserContext';
import {usePopup} from 'popup/PopupContext';
import AddMoneyPopupWrapper from 'components/donate/AddMoneyPopupWrapper';
import UniversalComplexInput from 'components/universal/input/UniversalComplexInput';

const commentPrice = 15;

const CommentInputArea = forwardRef(({
                                         isImageMy,
                                         postChatMessage,
                                         inputPlaceholder,
                                     }, ref) => {
    const {user} = useContext(UserContext);
    const {openPopup} = usePopup();
    const complexInputRef = useRef(null);

    useImperativeHandle(ref, () => ({
        clearInputAndBlur() {
            complexInputRef.current?.blurAndClear(); // Calls the focus method of UniversalComplexInput
        },
        focus() {
            complexInputRef.current?.focus(); // Calls the focus method of UniversalComplexInput
        }
    }));

    const sendMessage = (input) => {
        if (user.balance < commentPrice) {
            openPopup(<AddMoneyPopupWrapper initialAmount={commentPrice}/>);
            return;
        }
        postChatMessage(input);
        console.log('Sending message');
    };

    return (
        <UniversalComplexInput
            ref={complexInputRef}
            sendAmount={commentPrice}
            onSendMessageRequest={sendMessage}
            allowAllLetters={isImageMy}
            isPictureComment={true}
            inputPlaceholder={inputPlaceholder}
        />
    );
});

export default CommentInputArea;
